import React from "react";
import { Radar } from "react-chartjs-2";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";

// Registrar los componentes necesarios de Chart.js
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const AvanceProyectosRadar = ({ data }) => {
    // Extraer los valores
    const proyectos = data.map((item) => item.codigo);


    const avanceProgramado = data.map((item) => Math.round(parseFloat(item.total_meta)));
    const avanceEjecutado = data.map((item) => Math.round(parseFloat(item.total_meta_ejecutada)));

    const conversionData = [
        { rango: "0% - 50%", color: "rgba(242, 0, 19, 0.3)", descripcion: "Bajo", min: 0, max: 50 },
        { rango: "51% - 75%", color: "rgba(255, 165, 0, 0.3)", descripcion: "Medio", min: 51, max: 75 },
        { rango: "76% - 100%", color: "rgba(25, 135, 84, 0.3)", descripcion: "Alto", min: 76, max: 100 }
    ];

    // Función para obtener el color según el avance ejecutado
    const getColorForValue = (value) => {
        const range = conversionData.find(({ min, max }) => value >= min && value <= max);
        return range ? range.color : "#198754"; // Default a negro si no hay coincidencias
    };

    const metadata = data.map(item => ({
        grupoterritorial: item.grupoterritorial,
        implementador: item.implementador,
    }));



    // Definir datos para Chart.js
    const chartData = {
        labels: proyectos,
        datasets: [
            {
                label: "Meta Programada (P)",
                data: avanceProgramado,
                borderColor: "#118fe9",
                backgroundColor: "rgba(54, 162, 235, 0.3)",
                pointRadius: avanceProgramado.map((_, index) => (index % 2 === 0 ? 5 : 0)), // Alterna puntos visibles
                metadata
            },
            {
                label: "Meta Ejecutada (E)",
                data: avanceEjecutado,
                borderColor: avanceEjecutado.map(value => getColorForValue(value)), // Borde de los puntos
                backgroundColor: avanceEjecutado.map(value => getColorForValue(value)), // Color de los puntos
                pointRadius: avanceEjecutado.map((_, index) => (index % 2 === 0 ? 5 : 0)), // Alterna puntos visibles
                metadata
            },
        ],
    };

    // Opciones del gráfico
    const options = {
        responsive: true,
        scales: {
            r: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    font: {
                        size: 14, // Tamaño de fuente más grande

                    },
                    color: "#333", // Color oscuro para mejor contraste
                },
                pointLabels: {
                    font: {
                        size: 14, // Ajustar tamaño de etiquetas

                    },
                    color: "#333",
                },
            },
        },
        plugins: {
            legend: {
                position: "top",
                labels: {
                    font: {
                        size: 14,
                    },
                    color: "#333",
                },
            },
            tooltip: {
                callbacks: {
                    label: ({ dataIndex, dataset, raw, label }) => {
                        const meta = dataset.metadata[dataIndex];
                        return [
                            `${label}: ${raw}`,
                            `Grupo territorial: ${meta.grupoterritorial}`,
                            `Implementador: ${meta.implementador}`
                        ];
                    }
                },
            },
        },
    };


    return (
        <div style={{ width: "80%", height: "100%", paddingBottom: "40px" }}>
            <Radar data={chartData} options={options} />
        </div>
    );
};

export default AvanceProyectosRadar;
